import { setUpMobileHamburgerMenu } from 'js/simple_layout/header/setUpHeader';
import { throttle } from 'lodash';

function setUpStickyCtas(): void {
  let showingStickyCtas = false;

  const stickyCtasContainer = document.querySelector('.js-loswp-sticky-ctas');
  if (!stickyCtasContainer) return;

  const embeddedDocument = document.querySelector(
    '.js-loswp-embedded-document',
  ) as HTMLElement;

  // This is a hardcoded hack because when fetching the height of the element, it's 0
  // Note that if the designs change for the sticky ctas, this will need to be updated :\
  const stickyCtasHeight = 96;

  const stickyScrollHandler = throttle(() => {
    const scrollPosition = window.scrollY;
    const topOfEmbeddedDocument = embeddedDocument.offsetTop;
    const bottomOfEmbeddedDocument =
      topOfEmbeddedDocument + embeddedDocument.offsetHeight;

    const ctasStickToBottomOfPage = window.innerWidth <= 1280;
    const responsiveStickyCtasLowerCutoff = ctasStickToBottomOfPage
      ? bottomOfEmbeddedDocument - window.innerHeight
      : bottomOfEmbeddedDocument - stickyCtasHeight;
    const shouldShowStickyCtas =
      scrollPosition > topOfEmbeddedDocument &&
      scrollPosition < responsiveStickyCtasLowerCutoff;

    if (shouldShowStickyCtas && !showingStickyCtas) {
      showingStickyCtas = true;
      stickyCtasContainer.classList.remove('hidden');
    } else if (!shouldShowStickyCtas && showingStickyCtas) {
      showingStickyCtas = false;
      stickyCtasContainer.classList.add('hidden');
    }
  }, 250);
  window.addEventListener('scroll', stickyScrollHandler);
}

// alternateTrigger uses new possibly better method for toggling sticky elements
// (toggleable to avoid altering control behavior during LOSWP design tests)
export const setUpHeaders = () => {
  setUpMobileHamburgerMenu();
  setUpStickyCtas();
};
